<template>
  <v-dialog v-model="show">
    <v-card class="py-4 px-3">
      <v-btn @click="$emit('close')" icon class="float">
        <v-icon color="blue darken-4">close</v-icon>
      </v-btn>
      <v-layout mx-3 align-center column text-center>
        <span class="pt-3 subheading font-weight-medium">OH NÃO</span>
        <img
          width="45%"
          :src="require(`@/assets/logos/usecargonegativo.png`)"
        />
        <span class="pt-4 body-2 font-weight-regular"
          >O horário escolhido já foi agendado. Escolha um novo horário.</span
        >
        <span class="pt-4 pb-2 body-2 font-weight-regular"
          >Horários reservados {{ format(formatedDate) }}:</span
        >
        <v-data-table
          hide-actions
          :headers="headers"
          :items="requests"
          class="elevation-1 table-custom-vue"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                {{ item.begin_date | formatHour }}
              </td>
              <td>
                {{ item.end_date | formatHour }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import VehicleRequestController from "../../controllers/VehicleRequestController";
import moment from "moment";

export default {
  data() {
    return {
      vehicleRequestController: new VehicleRequestController(this.$resource),
      headers: [
        { text: "Check-in", value: "begin_date", sortable: false },
        { text: "Check-out", value: "end_date", sortable: false }
      ],
      requests: [],
      formatedDate: ""
    };
  },

  async created() {
    await this.getSchedule();
  },

  props: {
    show: Boolean,
    date: String
  },

  methods: {
    async getSchedule() {
      console.log(this.date);
      this.formatedDate = moment(this.date).format("YYYY-MM-DD");
      console.log(this.formatedDate);
      await this.vehicleRequestController
        .getTodayRequests(this.formatedDate)
        .then(res => {
          this.requests = res.body;
        })
        .catch(e => {
          console.log(e);
        });
    },

    format(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  },
  filters: {
    formatHour(hour) {
      return moment(hour).format("HH:mm");
    }
  }
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>
